var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Navbar',{attrs:{"NavbarMenu":_vm.NavbarMenu}}),_c('v-main',{staticClass:"bg"},[_c('v-container',[_c('v-row',[_c('Sidebar',{attrs:{"ContestSidebarMenu":_vm.ContestSidebarMenu,"MoreSidebarMenu":_vm.MoreSidebarMenu}}),_c('Main')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }